import { defineLocale } from "../composables/defineLocale.js";
export default defineLocale({
  name: "Ti\u1EBFng Vi\u1EC7t",
  code: "vi",
  messages: {
    inputMenu: {
      noMatch: "Kh\xF4ng c\xF3 k\u1EBFt qu\u1EA3 ph\xF9 h\u1EE3p",
      noData: "Kh\xF4ng c\xF3 d\u1EEF li\u1EC7u",
      create: 'T\u1EA1o "{label}"'
    },
    calendar: {
      prevYear: "N\u0103m tr\u01B0\u1EDBc",
      nextYear: "N\u0103m sau",
      prevMonth: "Th\xE1ng tr\u01B0\u1EDBc",
      nextMonth: "Th\xE1ng sau"
    },
    inputNumber: {
      increment: "T\u0103ng",
      decrement: "Gi\u1EA3m"
    },
    commandPalette: {
      placeholder: "Nh\u1EADp l\u1EC7nh ho\u1EB7c t\xECm ki\u1EBFm...",
      noMatch: "Kh\xF4ng c\xF3 k\u1EBFt qu\u1EA3 ph\xF9 h\u1EE3p",
      noData: "Kh\xF4ng c\xF3 d\u1EEF li\u1EC7u",
      close: "\u0110\xF3ng"
    },
    selectMenu: {
      noMatch: "Kh\xF4ng c\xF3 k\u1EBFt qu\u1EA3 ph\xF9 h\u1EE3p",
      noData: "Kh\xF4ng c\xF3 d\u1EEF li\u1EC7u",
      create: 'T\u1EA1o "{label}"',
      search: "T\xECm ki\u1EBFm..."
    },
    toast: {
      close: "\u0110\xF3ng"
    },
    carousel: {
      prev: "Tr\u01B0\u1EDBc",
      next: "Sau",
      goto: "\u0110i t\u1EDBi \xF4 {slide}"
    },
    modal: {
      close: "\u0110\xF3ng"
    },
    slideover: {
      close: "\u0110\xF3ng"
    },
    alert: {
      close: "\u0110\xF3ng"
    },
    table: {
      noData: "Kh\xF4ng c\xF3 d\u1EEF li\u1EC7u"
    }
  }
});
